import { PublicClientApplication, Configuration } from '@azure/msal-browser';

/*
 * Azure AD (Entra ID) access restriction for the AI Scoring frontend
 * (SCINFRA-686), mirroring the pattern already used by sc-internal-tool: a
 * public-client SPA registration (no client secret) authenticated via MSAL.
 *
 * Group restriction is enforced in Azure AD itself (Enterprise Application
 * "Assignment required" + the approved AZ group assigned) - not in this app.
 * A user outside that group never reaches loginRedirect() successfully.
 */

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID ?? '',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID ?? ''}`,
    redirectUri: '/',
  },
  cache: {
    cacheLocation: 'localStorage',
  },
};

/*
 * Minimal scopes - we only need an ID token to prove "signed in as a member
 * of the approved AZ group" to our own backend (which validates its audience
 * against our own client ID). No access token / "expose an API" setup in
 * Azure AD is needed for that.
 */
export const loginRequest = {
  scopes: ['openid', 'profile'],
};

export const msalInstance = new PublicClientApplication(msalConfig);
